module.exports = __webpack_public_path__ + "static/media/eupholidoptera_schmidti.bb132193.jpg";